module.exports = __webpack_public_path__ + "static/media/4.bb01633f.png";